import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { Cells } from './cells/cells'; // Assuming the class name is Cells
import { Offerings } from './offerings/offerings'; // Assuming the class name is Offerings
import { Dashboard } from './dashboard/dashboard';
import { Body } from './body/body';
import { Members } from './members/member-list/members';
import { Users } from './users/users';
import { MemberDetail } from './members/member-detail/member-detail'; // Import MemberDetailComponent
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { Settings } from './settings/settings'; // Import SettingsComponent
import { Profile } from './users/profile/profile';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { Reports } from './reports/reports/reports';
import { ReportPrev } from './reports/report-prev/report-prev';
import { ReportsOld } from './reports/reports-old/reports-old';
import { tutorialsGuard } from './tutorials/tutorials.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'auth/login' },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./auth-pages/auth-pages.route').then(
        (mod) => mod.AUTH_PAGES_ROUTES
      ),
  },
  {
    path: 'splash',
    loadComponent: () => import('./auth-pages/splash-screen/splash-screen').then(m => m.SplashScreenComponent),
    data: { title: 'Loading...' }
  },
  {
    path: 'select-church',
    loadComponent: () => import('./auth-pages/church-selector/church-selector').then(m => m.ChurchSelectorComponent),
    canActivate: [AuthGuard],
    data: { title: 'Seleccionar Iglesia' }
  },
  // Rutas públicas (Legal)
  {
    path: 'politicas-privacidad',
    loadComponent: () => import('./legal/privacy-policy/privacy-policy').then(m => m.PrivacyPolicyComponent),
    data: { title: 'Política de Privacidad' }
  },
  {
    path: 'terminos-servicio',
    loadComponent: () => import('./legal/terms-of-service/terms-of-service').then(m => m.TermsOfServiceComponent),
    data: { title: 'Términos de Servicio' }
  },
  {
    path: 'eliminar-cuenta',
    loadComponent: () => import('./legal/account-deletion/account-deletion').then(m => m.AccountDeletionComponent),
    data: { title: 'Eliminación de Cuenta' }
  },
  {
    path: 'dashboard',
    component: Body,
    canActivate: [AuthGuard],
    children: [
      { path: 'main', component: Dashboard, data: { skipViewTransition: true } }, // Default child route for dashboard
      { path: 'members', component: Members, data: { skipViewTransition: true } },
      { path: 'members/add', component: MemberDetail, canDeactivate: [unsavedChangesGuard], data: { skipViewTransition: true } },
      { path: 'members/edit/:id', component: MemberDetail, canDeactivate: [unsavedChangesGuard], data: { skipViewTransition: true } },
      { path: 'cells', component: Cells, data: { skipViewTransition: true } },
      { path: 'offerings', component: Offerings, data: { skipViewTransition: true } },
      { path: 'reports', component: ReportPrev, data: { skipViewTransition: true } },
      { path: 'reports/fiscal', loadComponent: () => import('./reports/fiscal-reports/fiscal-reports').then(m => m.FiscalReports), data: { skipViewTransition: true } },
      { path: 'preview-report', component: Reports, data: { skipViewTransition: true } },
      { path: 'reports-old', component: ReportsOld, data: { skipViewTransition: true } },
      { path: 'users', component: Users, data: { skipViewTransition: true } },
      { path: 'profile', component: Profile, data: { skipViewTransition: true } },
      { path: 'settings', component: Settings, data: { skipViewTransition: true } },
      {
        path: 'support',
        loadComponent: () => import('./support/support').then(m => m.SupportComponent),
        data: { skipViewTransition: true },
      },
      {
        path: 'support/:ticketId',
        loadComponent: () => import('./support/support-detail').then(m => m.SupportDetailComponent),
        data: { skipViewTransition: true },
      },
      {
        path: 'tutoriales',
        loadComponent: () => import('./tutorials/tutorials').then(m => m.TutorialsComponent),
        canActivate: [tutorialsGuard],
        data: { skipViewTransition: true },
      },
    ],
  }
]